<!--
  Component Info:
  1. Duplicate and modify from existing <service-item /> componenet
    - file path: src/views/Home/components/ServiceItem.vue
  2. <service-item /> is the section where it's list all of the service items for booking
    - each service items is actually using <expandable-list-item />
      - file path: src/components/ExpandableListItem.vue
  3. This component is called <e-store-product-listing /> instead of <e-store-item />
      - file name: EStoreProductListing.vue
      - use for product type of: service sale, retail product, and coupon
-->
<template>
  <div
    :class="[
      'px-4 pt-3 pb-4',
      cssClass,
    ]">
    <div
      v-for="data in items"
      :key="data.id"
      @click="handleItem && handleItem(data)"
    >
      <label
        class="scss-round-container d-flex flex-row mb-2 scss-click-effect"
      >
        <expandable-list
          class="flex-fill"
          :border="data.promotion">
          <expandable-list-header
              v-if="data.promotion"
              :content="getPromotionHeader(data)"/>
          <expandable-list-item
            :imgUrl="data.image"
            :name="data.name"
            :processingTime="formatProcessingTime(data.type, data.service?.processingTime)"
            :description="data.description"
            :originalPrice="data.originalPrice"
            :salePrice="data.salePrice"
            :clickable="false">
            <div class="d-flex flex-row align-items-center me-2">
              <icon-container
                iconClass="bi-cart-fill"
                :cssClass="'style-border'"
                @click.stop="addToCart(data.id)"/>
            </div>
          </expandable-list-item>
        </expandable-list>
      </label>
    </div>
    <div
      v-if="handleSeeAllButton"
      class="text-end fw-bold fst-italic mt-2"
      style="font-size: 14px"
    >
      <span class="scss-click-effect" @click="handleSeeAllButtonHandler"> See All >> </span>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import {
  formatProcessingTime,
  getPromotionHeader,
 } from "@/common/helpers/ProductHelper";
import { getToken } from "@/services/jwtService";
import IconContainer from "@/components/IconContainer.vue";
import ExpandableList from "@/components/ExpandableList.vue";
import ExpandableListHeader from "@/components/ExpandableListHeader.vue";
import ExpandableListItem from "@/components/ExpandableListItem.vue";

export default {
  name: "EStoreProductListing",
  components: {
    IconContainer,
    ExpandableList,
    ExpandableListHeader,
    ExpandableListItem,
  },
  props: {
    cssClass: String,
    productType: { // for listing usage
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    handleItem: {
      type: Function,
      required: false,
    },
    handleSeeAllButton: {
      type: Function,
      required: false,
    },
  },
  computed: {
    isLoggedIn() {
      return getToken() != null;
    },
  },
  methods: {
    formatProcessingTime,
    getPromotionHeader,
    handleSeeAllButtonHandler() {
      this.handleSeeAllButton(this.productType);
    },
    async addToCart(productId) {
      if (!this.isLoggedIn) {
        this.$router.push("/login");
        return;
      }

      store.commit("showLoading", true);
      await store.dispatch('postCart', {
        productId
      });
      store.commit("showLoading", false);
    }
  },
};
</script>
